export default "__VITE_IMAGE_ASSET__103b4df3__";